/**
 * Utility to reconstruct abstract from OpenAlex's inverted index
 */
export const reconstructAbstract = (invertedIndex: Record<string, number[]> | undefined | null): string | null => {
    if (!invertedIndex) return null;
    const abstractArray: string[] = [];
    Object.entries(invertedIndex).forEach(([word, positions]) => {
        positions.forEach(pos => {
            abstractArray[pos] = word;
        });
    });
    return abstractArray.join(' ');
};
